import React from 'react';
//import ReactDOM from 'react-dom';
import ReactDOM from "react-dom/client";

import { Provider } from 'react-redux'
//import {HashRouter as BrowserRouter} from 'react-router-dom'
import {BrowserRouter as BrowserRouter} from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline';

import AppAuthProvider from './utils/AppAuthContext'
import PlayProvider from './utils/PlayContext'
import store from './store/store';
import App from './App';
import reportWebVitals from './reportWebVitals'; 
import { MsalProvider } from '@azure/msal-react'; 
import { LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig,msalInstance } from './authConfig';



const root = ReactDOM.createRoot(document.getElementById("root"));
 
root.render(
  <React.StrictMode>
   <MsalProvider instance={msalInstance}> 
    <AppAuthProvider>
      <Provider store={store}>
        <PlayProvider>
                <BrowserRouter>
                    <CssBaseline />
                      <App />
                </BrowserRouter>
          </PlayProvider>
      </Provider>
    </AppAuthProvider>
    </MsalProvider>
  </React.StrictMode>
  //document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
